import { assertNever } from '@eversports/utility-types'

import { AddOn, AddOnField, AddOnsInitialValues } from './../../../typings/AdditionalInformation'

function getAddOnFieldValue(field: AddOnField, value: string | number | Array<string>) {
  switch (field.__typename) {
    case 'TextAddOnField':
      return {
        id: field.id,
        textValue: String(value),
      }
    case 'NumberAddOnField':
      return {
        id: field.id,
        numberValue: Number(value),
      }
    case 'SelectAddOnField':
      return {
        id: field.id,
        ...(Array.isArray(value) ? { multiSelectionValue: value } : { singleSelectionValue: String(value) }),
      }
    default:
      return assertNever(field)
  }
}

function getAddOnsValues(addOns: Array<AddOn>, values: AddOnsInitialValues) {
  return addOns.map(({ id, fields }) => ({
    id,
    fields: fields!.map((field) => getAddOnFieldValue(field, values[field.id])),
  }))
}

export default getAddOnsValues
